import React, { useState, MouseEvent, ChangeEventHandler } from 'react'
import ViewProps from '../../types/ViewProps'
import Answer from '../../types/Answer'
import QuestionState from '../../types/QuestionState'
import Typed from '../Typed'

export default ({ data, path, handleClick, appState, setAppState }: ViewProps) => {
    const q = data!.find(q => q.id === path)

    const [ questionState, setQuestionState ] = useState<QuestionState>({
        complete: false
    })
    
    if (appState[path!] === '') {
        setAppState({ ...appState, [path!]: ' ', next: q!.answers[0].target })
    }   

    const handleChange = (answer: Answer): void => {
        if (window.dataLayer) {
            window.dataLayer.push({ event: `radioChoice`, radioQuestion: q!.question, radioAnswer: answer.text });
        }
        setQuestionState({ complete: true })
        setAppState({ ...appState, [path!]: answer.text, next: answer.target })
    }

    const refresh = (event: MouseEvent): void => {
        setQuestionState({ complete: false })
        handleClick!(event)
    }

    const showNext = appState[path!] !== ' ' ? ' show' : ''
    const question = questionState.complete ? q!.question : <Typed>{q!.question}</Typed>

    return (
        <div>
            <div className="question">
                <div>
                    <h1>{question}</h1>
                    <div className={`answers answers-radio ${questionState.complete ? '' : 'animate'}`} style={{ animationDelay: `${q?.answerDelay}ms`}}>
                        {q?.answers.map((a, index) => 
                            <div key={a.text} className={`answer answer-radio`} onClick={() => handleChange(a)}>
                                <input type="radio" name={q.id} value={a.text} checked={appState[path!] === a.text} readOnly />
                                <span dangerouslySetInnerHTML={{ __html: a.text }}></span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div onClick={(e) => refresh(e)} className={`nav-link nav-link--landing${showNext}`}>Next</div>
        </div>
    )
}